import { loginValidationTooltip } from './login-validation-tooltip.entry';

declare namespace arjoJs {
  function isDesktop(): boolean;
}

const arjoHeaderMenu = {
  initialized: false,

  initMobile: function () {
    const body = document.querySelector('body');
    const hamburger = document.querySelector('.arjo-a-hamburger');
    const navMenu = document.querySelector('.arjo-o-header');
    const navLink = document.querySelectorAll('ul > li');
    const subNavMenu = document.querySelectorAll('ul.arjo-m-primary-nav-list');
    const btnSearch = document.querySelector('.arjo-m-search');
    const btnCloseSearch = document.querySelector('.arjo-m-search-close');
    const searchContainer = document.querySelector('.arjo-m-search-container');
    const btnSearchTopBar = document.querySelector('.arjo-m-nav-search');
    const tooltipMarker = document.querySelector<HTMLElement>('.arjo-o-header__tooltip-marker');
    const crossPortalMenu = document.querySelector('.arjo-o-eshop-cross-portal-menu');

    hamburger?.addEventListener('click', mobileMenu);
    btnSearch?.addEventListener('click', openSearch);
    btnSearchTopBar?.addEventListener('click', openSearch);
    btnCloseSearch?.addEventListener('click', closeSearch);
    navLink.forEach((n) => n.addEventListener('click', closeMenu));

    function mobileMenu() {
      hamburger?.classList.toggle('active');
      if (!hamburger?.classList.contains('active')) {
        subNavMenu.forEach((subNavItem) => subNavItem.classList.remove('open'));
      }
      navMenu?.classList.toggle('active');
      if (navMenu?.classList.contains('active')) {
        if (body) body.style.overflow = 'hidden';
        crossPortalMenu && crossPortalMenu.classList.add('active');
      } else {
        if (body) body.style.overflow = 'auto';
        crossPortalMenu && crossPortalMenu.classList.remove('active');
      }

      const hideAllTooltipKey = 'hide-all-region-change-tooltip';
      if (!localStorage.getItem(hideAllTooltipKey)) calculateTooltipPosition();
    }

    const calculateTooltipPosition = () => {
      const upperTooltip = tooltipMarker?.querySelector<HTMLElement>('.arjo-o-region-change-tooltip.upper');
      const lowerTooltip = tooltipMarker?.querySelector<HTMLElement>('.arjo-o-region-change-tooltip.lower');
      if (!upperTooltip || !lowerTooltip) return;

      const rect = tooltipMarker?.getBoundingClientRect();
      tooltipMarker?.style.setProperty('--marker-left', rect?.left + 'px');
      tooltipMarker?.style.setProperty('--upper-tooltip-height', upperTooltip.getBoundingClientRect().height + 'px');

      const lowerTooltipRect = lowerTooltip.getBoundingClientRect();
      if (rect && window.innerHeight - rect.bottom <= lowerTooltipRect.height + 10 + 12) {
        upperTooltip.style.zIndex = '10';
        upperTooltip.style.visibility = 'visible';
        lowerTooltip.style.removeProperty('z-index');
        lowerTooltip.style.removeProperty('visibility');
      } else {
        upperTooltip.style.removeProperty('z-index');
        upperTooltip.style.removeProperty('visibility');
        lowerTooltip.style.zIndex = '10';
        lowerTooltip.style.visibility = 'visible';
      }
    };

    function closeMenu() {
      hamburger?.classList.remove('active');
    }

    function openSearch() {
      searchContainer?.classList.toggle('open');
    }

    function closeSearch() {
      searchContainer?.classList.remove('open');
    }
  },

  initStickyMenu: function () {
    const navbar = document.querySelector<HTMLElement>('.arjo-o-header');
    const sticky = navbar?.offsetTop;
    const searchContainerDesktop = document.querySelector('.arjo-m-search-box-container');
    const autocompleteInput = searchContainerDesktop?.querySelector('.arjo-a-autocomplete');

    window.onscroll = function () {
      setStickyHeaderOnScroll();
    };

    function setStickyHeaderOnScroll() {
      const stickyNavTopValue = navbar ? window.getComputedStyle(navbar).getPropertyValue('--sticky-nav-top-desktop-value') : '0';

      if (window.scrollY > parseFloat(stickyNavTopValue)) {
        navbar?.classList.add('sticky');
        navbar && document.documentElement.style.setProperty('--header-height', Math.floor(navbar.getBoundingClientRect().bottom) + 'px');

        if (searchContainerDesktop) {
          searchContainerDesktop.classList.remove('open');
          // .header--opening help to prevent the page is scrolling up when user edit the search box on the header
          document.documentElement.classList.remove('header--opening');
          // Do this trick to be lost focus of the input tag
          autocompleteInput?.setAttribute('disabled', 'true');
          autocompleteInput?.removeAttribute('disabled');
          const resultList = searchContainerDesktop.querySelector<HTMLElement>('.arjo-a-autocomplete__result-list');

          if (resultList) resultList.innerHTML = '';
        }
      } else {
        navbar?.classList.remove('sticky');
        document.documentElement.style.removeProperty('--header-height');
      }
    }
  },

  showSubNavMobile: function () {
    const subNavLinks = document.querySelectorAll<HTMLElement>('ul.arjo-m-primary-nav-list > .nav-items > li.has-children');
    subNavLinks.forEach((item) => item.addEventListener('click', () => openSubNav(item)));

    function openSubNav(itemClicked: HTMLElement) {
      let subMenuContainer = itemClicked?.querySelector?.('ul')?.firstChild;
      subMenuContainer?.parentElement?.classList?.add?.('open');
    }
  },

  initScrollBreadcrumb: function () {
    const scrollElement = document.querySelector('.arjo-m-breadcrumb--insidescroll');
    if (scrollElement) {
      scrollElement.scrollLeft = scrollElement.scrollWidth + 10;
    }
  },

  initBackBtnMobile: function () {
    const btnBacks = document.querySelectorAll('.top-sub-nav__btn-back');
    btnBacks.forEach((item) => item.addEventListener('click', handleClickBackBtn));

    function handleClickBackBtn(event: Event) {
      event.stopPropagation();
      let itemClicked = event.target as HTMLElement;
      itemClicked?.closest?.('ul')?.classList?.remove('open');
    }
  },

  initDesktop: function () {
    const body = document.querySelector('body');
    const primaryNavLinks = document.querySelectorAll<HTMLElement>('ul > .nav-items > li.has-children');
    primaryNavLinks.forEach((menuItem) => menuItem.addEventListener('click', () => showMegaMenu(menuItem)));
    const searchIcon = document.querySelector('.arjo-m-search-icon');
    const navbar = document.querySelector('.arjo-o-header');

    // toggle searchbar when sticky menu
    searchIcon?.addEventListener('click', showSearchBar);

    // handle click outside
    window.addEventListener('click', closeClickOutside);
    window.addEventListener('scroll', updateCurrentHeaderHeight);

    function updateCurrentHeaderHeight() {
      document.documentElement.style.setProperty('--current-header-height', navbar?.getBoundingClientRect().bottom + 'px');
    }

    function showMegaMenu(menuItemClicked: HTMLElement) {
      // hide all the mega menu first before show the mega menu of current menuItemClicked
      primaryNavLinks.forEach((menuItem) => {
        if (menuItem.classList.contains('show-megamenu')) {
          menuItem.classList.remove('show-megamenu');
        }
      });

      menuItemClicked?.classList?.add?.('show-megamenu');
      let btnCloseMegaMenu = menuItemClicked?.querySelector?.('li.top-sub-nav .top-sub-nav__close-megamenu');
      btnCloseMegaMenu?.addEventListener?.('click', hideMegaMenu);
      if (body) body.style.overflow = 'hidden';
    }

    function hideMegaMenu(event: Event) {
      event.stopPropagation();
      const menuItemClicked = event.target as HTMLElement;
      menuItemClicked?.closest?.('.has-children')?.classList?.remove?.('show-megamenu');
      if (body) body.style.overflow = 'auto';
    }

    function showSearchBar(event: Event) {
      event.stopPropagation();
      const searchBarContainer = (event.target as HTMLElement).parentElement;
      if (!searchBarContainer?.classList?.contains?.('open')) {
        searchBarContainer?.classList?.add?.('open');
        // .header--opening help to prevent the page is scrolling up when user edit the search box on the header
        document.documentElement.classList.add('header--opening');
        // search box classList cannot be modified on first click, work around by hardcode, todo: remove hard code
        document.body.style.setProperty('--search-box-width', '239px');
      } else {
        searchBarContainer.classList.remove('open');
        document.documentElement.classList.remove('header--opening');
        document.body.style.removeProperty('--search-box-width');
      }
    }

    function closeClickOutside(event: Event) {
      // hide search bar when click outside
      const elementClicked = event.target as HTMLElement;
      const navContainer = document.querySelector('li.has-children.show-megamenu');

      if (navContainer && !navContainer.contains(elementClicked)) {
        navContainer.classList.remove('show-megamenu');
        if (body) body.style.overflow = 'auto';
      }
    }

    updateCurrentHeaderHeight();
  },

  initLoginAccessValidation: function () {
    const loginLink = document.querySelector<HTMLAnchorElement>('.arjo-a-link[data-menu-id="login-link"]');

    if (!loginLink) return;

    loginLink.addEventListener('click', onLoginValidation);

    function redirectToLoginPage(loginUrl: string) {
      if (loginUrl) window.location.href = loginUrl;
    }

    function onLoginValidation(event: Event) {
      const loginUrl = loginLink?.getAttribute('href') || '';
      const loginValidationUrl = loginLink?.dataset?.ajaxUrl;
      const disabling = loginLink?.classList?.contains('disabled');

      event.preventDefault();

      if (disabling || (loginValidationTooltip && loginValidationTooltip.isTooltipShowing)) return;

      if (loginValidationUrl) {
        loginLink?.classList?.add('disabled');

        fetch(loginValidationUrl)
          .then((res) => {
            if (!res.ok) throw new Error('login failed');

            redirectToLoginPage(loginUrl);
          })
          .catch(() => {
            loginValidationTooltip && loginValidationTooltip.dispatchShowTooltipEvent();
          })
          .finally(() => {
            loginLink?.classList?.remove('disabled');
          });
      } else {
        redirectToLoginPage(loginUrl);
      }
    }
  },
};

window.onload = function() {
  if (arjoHeaderMenu.initialized) return;

  if (arjoJs.isDesktop()) {
    arjoHeaderMenu.initDesktop();
  } else {
    arjoHeaderMenu.initMobile();
    arjoHeaderMenu.showSubNavMobile();
    arjoHeaderMenu.initBackBtnMobile();
    arjoHeaderMenu.initScrollBreadcrumb();
  }
  arjoHeaderMenu.initStickyMenu();
  arjoHeaderMenu.initLoginAccessValidation();

  arjoHeaderMenu.initialized = true;
};
